
import { useEffect, useState } from 'react';
import "./videocursos-on-deman/CursosDinamicos.css";
import './dj/DJ.css';
// import { db } from "../../firebase/firebase";
// import { cursos, imgHeaderOnDemand } from './dj/ArraysDataBaseCursosOnDemand';
import { TarjetasCursosImagen } from './dj/TarjetasCursosImagen';
import AnimatedBackground2 from './videocursos-on-deman/AnimateBackground2';
import { ArrayCursos } from './dj/ArraysCursosOnDemand';


const cursos = ["",""];

export const Videocursos = () => {
    const [cursosEncontrados, setCursosEncontrados] = useState([]);



    useEffect(() => {
        const cursosLeidos = cursos.map(doc => ({
            cursoId: doc.cursoId,
            nombre: doc.nombre || "",
            descripcion: doc.descripcion || "",
            img:doc.img || "",
        }));

        setCursosEncontrados(cursosLeidos);
    }, [setCursosEncontrados]);

    // useEffect(() => {
        
    //     const leerCursosEncontrados = async () => {
    //         try {
    //         const snapshot = await db.collection("cursos_privados").get();
    //         const cursosLeidos = snapshot.docs.map(doc => ({
    //             cursoId: doc.id,
    //             titulo: doc.data().nombre || "",
    //             descripcion: doc.data().descripcion || "",
    //             img:""
    //         }));
    
    //         setCursosEncontrados(cursosLeidos);
    //         } catch (error) {
    //         console.error("❌ Error al leer cursos privados:", error);
    //         }
    //     };

    //     leerCursosEncontrados();
    // }, []);



  return (
    <div className="app-wrapper position-relative">

        {/* Fondo con círculos animados */}
        {/* <div className="background-gradient position-fixed w-100 h-100 top-0 start-0 z-n1"></div> */}

        <AnimatedBackground2/>

        <div className="content position-relative">

            <header
                className="animate__animated animate__fadeIn animate__slow" 
                // style={dynamicHeight()}
                style={{
                    width: "100%",
                    // margin: "100px auto 0 auto",
                    height: "300px",
                    position: "relative",
                    // boxShadow: "0 0px 15px rgba(255, 255, 255, 0.6)",
                }}
            >
                {/* Imagen de fondo en Header */}
                <div
                    className="background-img"
                    style={
                        {  
                            // backgroundImage: `url(${imgHeaderOnDemand?.imgHeaderOnDemand})`, 
                            // filter:"saturate(0)", 
                            opacity:"0.1"
                        }
                    }
                >
                </div>
                {/* Overlay oscuro con opacidad al 10% */}
                <div className='overlay-img-videocursos' style={{filter:"invert(1)", backgroundColor:"rgba(206, 206, 206, 0.1)"}}></div>

                <div className='texto-header w-100 text-center text-white d-flex flex-column justify-content-center align-items-center h-100' style={{padding:"0rem"}}>
                    <h1 className='text-white text-center fs-5'>
                        Cursos de Producción
                        
                    </h1>
                        {/* <span class="glass-icon" style={{margin:"0 auto"}}>
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 24 24" 
                                fill="currentColor" 
                                width="28" 
                                height="28"
                                class="icon-play"
                            >
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                         </span>  */}
                    

                    <h6 style={{textAlign:"center", fontSize:"12px", fontWeight:"300", margin:"10px 0"}}>
                        Accede a una formación completa para productores, disponible cuando y donde quieras.
                    </h6>
                </div>
            </header>

            <main>
                {cursosEncontrados.length === 0 ? (
                    <div className="mx-auto w-100 d-flex justify-content-center">
                        <div style={{ textAlign: 'center', marginTop: '3rem', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <h3 style={{ margin: 'auto', padding:"0"}}>CARGANDO CURSOS</h3>
                            <div className="spinner-border text-white mx-2 my-auto" role="status"></div>
                        </div>
                    </div>
                ) : (
                    <TarjetasCursosImagen ArrayCursos={ArrayCursos} onDemand={true} inicio={true} />
                )}
            </main>
        </div>

    </div>
  )
}
